import { IJob } from 'types/income';
import { Job, JobState } from './jobs.types';

const convertJobStatus = (job: IJob): Job => {
  const state: JobState =
    job.status === 'completed'
      ? 'success'
      : job.status === 'failed'
      ? 'error'
      : 'loading';

  const progress =
    typeof job.progress === 'object' && job.progress ? job.progress : undefined;
  const completedTasks = progress?.completedTasks ?? [];
  const currentTask = progress?.currentTask ?? '';
  const percent = progress?.percent ?? 0;

  const tasks = [
    ...completedTasks.map((task) => ({
      name: task.name,
      status: 'completed' as const,
    })),
    ...(state === 'loading' && currentTask
      ? [{ name: currentTask, status: 'active' as const }]
      : []),
  ];

  return {
    ...job,
    progress: {
      completedTasks,
      currentTask,
      percent,
    },
    percent,
    state,
    currentTask,
    tasks,
  };
};

export const converters = {
  getJobStatus: ({ data }: { data: IJob }) => convertJobStatus(data),
};
